import server from '@/request/encryptRequest';

export const promoterList = (data) => {
  return server.post('/xiaozi-saas/wireless/promoter/pageList', data);
};

export const promoterInviteUserPageList = (data) => {
  return server.post('/xiaozi-saas/wireless/promoter/promoterInviteUserPageList', data);
};
